import { useFormContext } from 'react-hook-form';

export default function useApplyEventAIData() {
  const formContext = useFormContext();
  const setValue = formContext?.setValue;

  const applyEventData = (data) => {
    if (!data || !setValue) return null;

    const payload = data?.msgResp || data;
    const parsedData = {};

    if (payload?.title) {
      parsedData.title = payload.title;
    }

    if (payload?.description) {
      parsedData.description = payload.description;
    }

    if (payload?.pickupAddress) {
      parsedData.location = payload.pickupAddress;
    }

    if (payload?.comment) {
      parsedData.importantNotes = payload.comment;
    }

    if (Array.isArray(payload?.products) && payload?.products?.length > 0) {
      parsedData.items = payload?.products.map((product, index) => ({
        id: Date.now() + index,
        name: product?.name || '',
        description: product?.description || '',
        price: product?.price || null,
        image: product?.photoUrls?.[0] || '',
        maxQuantity: 1000,
        limitPerOrder: 1000,
        minOrderQty: 1,
        subItems: [],
        splitCasePurchase: null,
      }));
    }

    if (payload?.imageUrl) {
      parsedData.banners = [
        {
          id: Math.random().toString(36).substring(2, 9),
          url: payload.imageUrl,
        },
      ];
    }

    Object.entries(parsedData).forEach(([key, value]) => {
      setValue(key, value, { shouldValidate: true, shouldDirty: true });
    });

    return parsedData;
  };

  return { applyEventData };
}
